import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-podcast-row',
  templateUrl: './skeleton-podcast-row.component.html',
  styleUrls: ['./skeleton-podcast-row.component.scss'],
  standalone: false
})
export class SkeletonPodcastRowComponent {}
